<div class="max-w-5xl mx-auto p-6">

  <div *ngIf="isLoading" class="text-center py-4 text-gray-500 dark:text-gray-400">
    Cargando disponibilidad...
  </div>

  <div *ngIf="errorMessage" class="p-3 mb-3 rounded-lg bg-error-50 dark:bg-error-500/10 border border-error-200 dark:border-error-500/20 text-error-600 dark:text-error-400 text-sm">
    {{ errorMessage }}
  </div>

  <!-- TABS (TIPO REUNIÓN) -->
  <div class="flex gap-3 mb-6 flex-wrap">
    <button *ngFor="let type of meetingTypes"
      (click)="selectType(type)"
      class="flex flex-col items-center justify-center px-5 py-3 rounded-2xl text-sm transition-colors min-w-[140px] border"
      [ngClass]="selectedTypeId === type.id
        ? 'bg-brand-500 text-white border-brand-500'
        : 'bg-white dark:bg-white/[0.03] text-gray-700 dark:text-gray-300 border-gray-200 dark:border-gray-800 hover:bg-gray-50 dark:hover:bg-white/[0.05]'">

      <!-- ICONO + NOMBRE -->
      <div class="flex items-center gap-2 font-medium">
        <span *ngIf="type.icon">{{ type.icon }}</span>
        <span>{{ type.name }}</span>
      </div>

      <!-- DURACIÓN -->
      <div class="text-xs mt-1 opacity-80">
        ({{ type.duration }} minutos)
      </div>
    </button>
  </div>

  <!-- CARD -->
  <div class="overflow-hidden rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03] p-6">

    <!-- HEADER -->
    <div class="flex justify-between items-center mb-6">
      <div>
        <h2 class="text-lg font-semibold text-gray-800 dark:text-white/90">Disponibilidad</h2>
        <p class="text-sm text-gray-500 dark:text-gray-400">
          Define los horarios en los que estás disponible
        </p>
      </div>
    </div>

    <!-- DÍAS -->
    <div class="space-y-4">
      <div *ngFor="let day of days"
        class="rounded-xl p-4 border border-gray-200 dark:border-white/[0.05] bg-gray-50 dark:bg-white/[0.02]">

        <!-- HEADER DÍA -->
        <div class="flex justify-between items-center mb-3">
          <div class="flex items-center gap-3">
            <!-- SWITCH -->
            <button (click)="toggleDay(day.key)"
              class="w-11 h-6 flex items-center rounded-full p-1 transition-colors"
              [ngClass]="week[day.key].enabled ? 'bg-brand-500' : 'bg-gray-300 dark:bg-gray-600'">
              <div class="bg-white w-4 h-4 rounded-full shadow transform transition-transform"
                [ngClass]="week[day.key].enabled ? 'translate-x-5' : ''"></div>
            </button>

            <!-- NOMBRE -->
            <span class="font-medium text-sm w-24 text-gray-800 dark:text-white/90">
              {{ day.label }}
            </span>
          </div>

          <!-- BOTÓN AGREGAR -->
          <button *ngIf="week[day.key].enabled"
            (click)="addSlot(day.key)"
            class="text-sm text-brand-500 hover:text-brand-600 dark:text-brand-400 dark:hover:text-brand-300 font-medium">
            + Agregar horario
          </button>
        </div>

        <!-- SLOTS -->
        <div *ngIf="week[day.key].enabled" class="flex flex-col gap-2">
          <div *ngFor="let slot of week[day.key].slots; let i = index"
            class="flex items-center gap-2">

            <input type="time" [(ngModel)]="slot.start"
              (change)="onChange(); validateDay(day.key)"
              class="px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white/90 w-28" />

            <span class="text-gray-400 dark:text-gray-500">—</span>

            <input type="time" [(ngModel)]="slot.end"
              (change)="onChange(); validateDay(day.key)"
              class="px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white/90 w-28" />

            <!-- ELIMINAR -->
            <button (click)="removeSlot(day.key, i)"
              class="text-error-500 hover:text-error-600 dark:text-error-400 dark:hover:text-error-300 text-sm px-2">
              ✕
            </button>
          </div>
        </div>

        <!-- NO DISPONIBLE -->
        <div *ngIf="!week[day.key].enabled"
          class="text-sm text-gray-400 dark:text-gray-500">
          No disponible
        </div>
      </div>
    </div>

    <!-- FOOTER -->
    <div class="flex justify-between items-center mt-6 flex-wrap gap-3">

      <!-- CONFIG -->
      <div class="flex gap-6 flex-wrap">
        <div>
          <label class="text-xs text-gray-500 dark:text-gray-400 block mb-1">
            Buffer entre reuniones
          </label>
          <select [(ngModel)]="buffer"
            class="px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white/90">
            <option [value]="5">5 min</option>
            <option [value]="10">10 min</option>
            <option [value]="15">15 min</option>
          </select>
        </div>

        <div>
          <label class="text-xs text-gray-500 dark:text-gray-400 block mb-1">
            Máximo por día
          </label>
          <select [(ngModel)]="dailyLimit"
            class="px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white/90">
            <option [value]="1">1</option>
            <option [value]="2">2</option>
            <option [value]="3">3</option>
          </select>
        </div>
      </div>

      <!-- BOTÓN GUARDAR -->
      <button (click)="save()"
        class="px-5 py-2 rounded-xl bg-brand-500 text-white hover:bg-brand-600 transition-colors font-medium">
        Guardar
      </button>
    </div>
  </div>
</div>
